import globals from "imports/globals";
import $ from "cash-dom";
import { ScrollTween2 as ScrollTween, mapValue } from "Utilities";

const component = (function () {
    /**
     * Initialize Hero instances
     */
    $(document).ready(function () {
        if ($("[data-parallax]").length) {
            if (globals.debug) console.log("component-parallax initialized");
            var factor;
            var distance = globals.screenOrientation == "portrait" ? window.innerWidth : window.innerHeight;
            $("[data-parallax]").each(function () {
                var element = $(this)[0];
                new ScrollTween({
                    element: element,
                    from: "top-bottom",
                    to: "bottom-top",
                    callback: function (_n, _el) {
                        switch (_el.getAttribute("data-parallax")) {
                            case "sm":
                                factor = 0.08;
                                break;
                            case "md":
                                factor = 0.16;
                                break;
                            case "lg":
                                factor = 0.24;
                                break;
                        }
                        var from = distance * factor;
                        var to = from * -1;
                        var val = mapValue(_n, 0, 1, from, to);
                        _el.style.transform = `translate3d(0, ${val}px, 0)`;
                    },
                });
            });

            $(window).on("resizeEnd", function () {
                distance = globals.screenOrientation == "portrait" ? window.innerWidth : window.innerHeight;
            });
        }
    });
})();

export default component;
